import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Alert from "react-bootstrap/Alert";
import { rolesAndPermissionsManagement } from "../util/headcells-util";
import { fetchRoles } from "../services/users-service";

const RolesAndPermissionsManagement = () => {
  const [isUpdated, setIsUpdated] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rolesData, setRolesData] = useState(null);

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return <div></div>;
  };

  const renderBannerMessage = () => {
    if (isUpdated) {
      return "User has been successfully updated!";
    } else if (isError) {
      return "Something went wrong, please try again";
    }
  };

  const getRolesData = useCallback(async () => {
    let response = await fetchRoles(pageNo, recordsPerPage);
    if (response.ok) {
      let data = await response.json();
      if (data.genericList != null) {
        setIsFetchError(false);
        setIsError(false);
        setRolesData(data);
      } else {
        setIsFetchError(true);
        setIsError(true);
      }
    } else {
      setIsFetchError(true);
      setIsError(true);
    }
  }, [pageNo, recordsPerPage]);

  useEffect(() => {
    getRolesData();
  }, [pageNo, recordsPerPage, getRolesData]);

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">
              Roles and Permissions Management
            </Row>
            <Row className="tableSubtitle generalFont">View all the Roles</Row>
          </Col>
        </Row>
        {(isUpdated || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsUpdated(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}

        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={rolesAndPermissionsManagement}
          rows={rolesData?.genericList}
          pages={rolesData?.totalPages}
          buttonsLayout={buttonsLayout}
          setSelectedRowCallback={setSelectedRowCallback}
          isRoleAndPermissionsScreen={true}
        />
      </Container>
    </>
  );
};

export default RolesAndPermissionsManagement;
